import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import Home from './../pages/home/homeComponent';
import Pass from './../pages/pass/passComponent';
import Confirmation from './../pages/pass/confirmationComponent';
import paymentResponse from './../pages/pass/paymentResponse';
import paymentFailed from './../pages/pass/paymentFailed';
import failedComponent from './../pages/pass/failedComponent';
import HeaderComponent from './../common/header';
import FooterComponent from './../common/footer/footer';
import directBookingResponse from '../pages/pass/directBookingResponse';
class MainRoutes extends Component {
    // constructor(props) {
    //     super(props);
    // }
    componentWillReceiveProps(nextProps) {
        if (nextProps.location !== this.props.location) {
          this.setState({ prevPath: this.props.location })
        }
      }

    render() {
        return (
            <Router>
                <HeaderComponent></HeaderComponent>
                {this.props.children}
                <Switch>
                    <Route exact path="/" component={Home} ></Route>
                    <Route path="/checkout-passes" component={Pass} ></Route>
					{/* Redirection URL */}
					<Route path="/paymentResponse" component={paymentResponse} ></Route>
					<Route path="/paymentFailed" component={paymentFailed} ></Route>
                     {/* After Payment Redirection URL */}
					<Route path="/payment-success" component={Confirmation} ></Route>
					<Route path="/payment-failure" component={failedComponent} ></Route>
                    {/* Direct Booking and Success */}

                    <Route path="/booking-response" component={directBookingResponse} ></Route>
					
                    {/* <Redirect from="/about-us" to="/" />
                    <Redirect from="/request-a-demo" to="/" /> */}
                    
                    {/* <Route path="/about-us" component={AboutUs} ></Route>
                    <Route path="/services/:serviceName" component={ServiceDetails} ></Route>
                    <Route path="/services" component={Services} ></Route>
                    <Route path="/payment" component={AddToCart} ></Route>
                    <Route path="/make-Payment" component={Payment} ></Route>
                    
                    <Route path={`/service-detail`} component={ServiceDetails} ></Route>
                    <Route path="/solutions" component={Solutions} ></Route>
                    <Route path="/our-team" component={OurTeam} ></Route>
                    <Route path="/company-profile" component={CompanyProfile} ></Route>
                    <Route path="/industries" component={Industries} ></Route>
                    <Route path="/support" component={Support} ></Route>
                    <Route path="/request-a-demo" component={RequestADemoPage} ></Route>
                    <Route path="/useful-links" component={UsefulLinks} ></Route>
                    <Route path="/privacy-policy" component={PrivacyPolicy} ></Route>
                    <Route path="/request-trial" component={RequestTrial} ></Route>
                    <Route path="/thank-you" component={ThankYouRequestTrial}></Route>
                    <Route path="/login" component={Login} ></Route>
                    <Route path="/forget-password" component={ForgetPassword} ></Route>
                    <Route path="/reset-password/:token" component={ResetPassword} ></Route>
                    <Route path="/generate-new-password/:token" component={GenerateNewPassword} ></Route>
                    <Route path="/contact-us" component={ContactUs} ></Route>
                    <Route path="/terms-condition" component={TermsConditions} ></Route>
                    <Route path="/privacy-policy" component={PrivacyPolicy} ></Route>
                    <Route path="/news" component={RedirectNews} ></Route> */}
                    {/* <Route path="/payment-history" component={PaymentHistory} ></Route> */}
                    {/* <Route path="/user">
                        <UserComponent></UserComponent>
                        <Route path="/payment-history" component={PaymentHistory} ></Route>
                    </Route> */}
                    
                    {/* <Route path="/logout" component={Logout} ></Route> */}
                    
                    <Route component={Home} ></Route>
                    <Route path="*">
                        <Redirect to="/" />
                    </Route>
                </Switch>
                <FooterComponent></FooterComponent>
            </Router>
        )
    }
}

export default MainRoutes